import { z } from 'zod';

// News runs / leaderboard (#447): GET /api/topics/{id}/sharing-runs.
// totalRuns counts every run including in-flight ones; completedRuns lists
// only runs that reached the effective race goal, fastest first.

const NewsRunSummarySchema = z.object({
  startingLegId: z.string(),
  allowedSenderName: z.string(),
  impressions: z.number().int().nonnegative(),
  timeToGoalSeconds: z.number().int().nonnegative(),
  degreesOfSeparation: z.number().int().nonnegative(),
  startedAt: z.string().datetime({ offset: true }),
});

export const NewsRunsSchema = z.object({
  impressionGoal: z.number().int().positive().nullable(),
  totalRuns: z.number().int().nonnegative(),
  completedRuns: z.array(NewsRunSummarySchema),
});

export type NewsRuns = z.infer<typeof NewsRunsSchema>;
export type NewsRunSummary = z.infer<typeof NewsRunSummarySchema>;
